import AnyPage from "./AnyPage";
import Auth from "./Pages/Auth";
import ProductSearch from "./Pages/ProductSearch";
import Cart from "./Pages/Cart";
import Profile from "./Pages/Profile";
import Shipping from "./Pages/Shipping";
import ArticleSearch from "./Pages/ArticleSearch";

export default {
    default: {
        instance: new AnyPage(),
        urls: []
    },
    Auth: {
        instance: new Auth(),
        urls: [
            "users/login",
            "users/login/confirm",
        ]
    },
    Product: {
        instance: new ProductSearch(),
        urls: [
            "products/search",
        ]
    },
    Cart: {
        instance: new Cart(),
        urls: [
            "checkout/cart",
            "products/**",
            "", // index page
        ]
    },
    Profile: {
        instance: new Profile(),
        urls: [
            "users/profile",
            "users/profile/personal-info",
            "users/profile/addresses",
            "checkout/shipping",
        ]
    },
    Shipping: {
        instance: new Shipping(),
        urls: [
            "checkout/shipping",
        ]
    },
    Article: {
        instance: new ArticleSearch(),
        urls: [
            "articles",
        ]
    },
}